import axios from "axios";
import { API_URL } from "../../config/config";
import API from "../../common/API";

/*** 
@purpose : Get time range list
@Parameter : {}
**/
export const fetchTimeRangeList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(API_URL + API.GET_TIME_RANGE_LIST + `?timestamp=${timestamp}`, {
      headers: {
        "x-api-key": token,
        "Access-Control-Allow-Origin": "*",
        mode: "no-cors",
      },
    })
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get time range list
@Parameter : {}
**/
export const fetchEmailSettingsList = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        API.LIST_EMAIL_SETTINGS +
        `?wwid=${body.id ? body.id : ""}&limit=${
          body.limit ? body.limit : 0
        }&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get time range list
@Parameter : {}
**/
export const sortEmailSettingsList = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        API.LIST_EMAIL_SETTINGS +
        `?wwid=${body.id ? body.id : ""}&sort_field=${
          body.sort_field ? body.sort_field : ""
        }&sort_order=${
          body.sort_order ? body.sort_order : ""
        }&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get employe by wwid
@Parameter : {}
**/
export const fetchEmployeeByWwid = async (wwid) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL + API.GET_EMPLOYEE_NAME + `?wwid=${wwid}&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get employe by wwid
@Parameter : {}
**/
export const fetchEmailEmployeeName = async (wwid) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        API.GET_EMAIL_EMPLOYEE_NAME +
        `?wwid=${wwid}&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get org level list
@Parameter : {}
**/
export const fetchOrgLevelList = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return fetch(API_URL + API.GET_ORG_LEVEL_LIST, {
    method: "post",
    headers: {
      "x-api-key": token,
      "Access-Control-Allow-Origin": "*",
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Add time settings
@Parameter : {}
**/
export const addTimeSettings = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return fetch(API_URL + API.ADD_EMAIL_SETTINGS, {
    method: "put",
    headers: {
      "x-api-key": token,
      "Access-Control-Allow-Origin": "*",
      mode: "no-cors",
      language: sessionStorage.getItem("Language"),
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Add email settings
@Parameter : {}
**/
export const addEmailSettings = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return fetch(API_URL + API.ADD_EMAIL_SETTINGS, {
    method: "post",
    headers: {
      "x-api-key": token,
      "Access-Control-Allow-Origin": "*",
      mode: "no-cors",
      language: sessionStorage.getItem("Language"),
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Delete email settings
@Parameter : {}
**/
export const deleteEmailSettings = async (body) => {
  const token = sessionStorage.getItem("token");
  return fetch(API_URL + API.DELETE_EMAIL_SETTINGS, {
    method: "delete",
    headers: {
      "x-api-key": token,
      "Access-Control-Allow-Origin": "*",
      mode: "no-cors",
      language: sessionStorage.getItem("Language"),
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};
